const Item = (props) => {
    return (
        <div
            key={props.permission.Id}
            className="flex items-start justify-between gap-4 py-3"
        > -
            <span className="flex-1 text-sm text-gray-700">
                {props.permission.Description}
            </span>
            <input
                type="checkbox"
                disabled={!props.isEditor}
                className="mt-0.5 h-4 w-4 accent-personalized"
                checked={props.permission.checked}
                onChange={(e) => props.updateCheck(props.permission.Id, e.target.checked)}
            />
        </div>
    );
};

export default Item;
